import {useTranslation} from 'react-i18next'
import {Button} from '@/components/ui/button'
import {HelpIcon} from '@/components/help-icon'
import type {components} from '@/lib/api-schema'

export type AccionSugerida = components['schemas']['AccionSugeridaRead']

/** Authored-minus-created suggestions, derived fresh by the backend on every read; nothing here writes. */
export function AccionSugeridaList({
  acciones,
  onCrear,
  ayuda = false,
}: {
  acciones: AccionSugerida[]
  onCrear: (titulo: string) => void
  /** Solo donde la lista aparece una vez por pantalla; en el plan se repite por grupo. */
  ayuda?: boolean
}) {
  const {t} = useTranslation()
  if (acciones.length === 0) return null
  return (
    <div className="mt-2 space-y-1.5" data-testid="acciones-sugeridas">
      <span className="flex items-center gap-1.5">
        <p className="font-mono text-[9px] font-medium tracking-wider text-muted-foreground uppercase">
          {t('sgsst.sugeridas.title')}
        </p>
        {ayuda && (
          <HelpIcon
            label={t('common.help.iconLabelFor', {campo: t('sgsst.sugeridas.title')})}
            testId="acciones-sugeridas-help">
            {t('sgsst.sugeridas.help')}
          </HelpIcon>
        )}
      </span>
      <ul className="space-y-1.5">
        {acciones.map((accion) => (
          <li
            key={accion.titulo}
            className="flex flex-wrap items-center justify-between gap-2 rounded-md bg-secondary/50 px-2.5 py-1.5"
            data-testid="accion-sugerida-item">
            <span className="text-sm text-foreground">{accion.titulo}</span>
            <Button
              type="button"
              size="sm"
              variant="outline"
              data-testid="accion-sugerida-crear"
              onClick={() => onCrear(accion.titulo)}>
              {t('sgsst.sugeridas.crearEstaAccion')}
            </Button>
          </li>
        ))}
      </ul>
    </div>
  )
}
